export const localFeatureIds = [
  //
  'export video',
  'ss onboarding',
  'smartlook-canvas',
  'onboarding-pro-schedule',
  'sourcing-assistant',
  'design-assistant',
  'signup-tracking-page',
  'price-alert',
  'slazzer',
  'viz-demo-overlay',
  'viz-take-photo-button',
  'search-with-image-embedding',
  'viz-manual-distort',
  'viz-magic-render-floorplan',
] as const

export const externalFeatureIds = [
  //
  'smartlook-canvas',
  'onboarding-pro-schedule',
  'sourcing-assistant',
  'design-assistant',
  'signup-tracking-page',
  'price-alert',
  'slazzer',
  'viz-demo-overlay',
  'viz-take-photo-button',
  'search-with-image-embedding',
  'viz-manual-distort',
  'viz-magic-render-floorplan',
] as const

export type LocalFeatureId = (typeof localFeatureIds)[number]
export type ExternalFeatureId = (typeof externalFeatureIds)[number]
export type FeatureId = LocalFeatureId | ExternalFeatureId

export function isLocalFeature(
  featureId: FeatureId,
): featureId is LocalFeatureId {
  return localFeatureIds.includes(featureId as LocalFeatureId)
}

export function isExternalFeature(
  featureId: FeatureId,
): featureId is ExternalFeatureId {
  return externalFeatureIds.includes(featureId as ExternalFeatureId)
}
